// Kicks off the Stripe Checkout redirect for a Pro upgrade. Shared by the
// ProUpgradeDialog (every in-app Pro gate) and the /pro marketing page so both
// hit the same endpoint and surface identical errors. Throws on failure so the
// caller can show the message and reset its own loading state.
export async function startProCheckout(): Promise<string> {
  const response = await fetch(`/api/billing/checkout`, { method: `POST` })
  const result = await response.json()

  if (!response.ok || !result.url) {
    throw new Error(result.error || `Unable to start checkout`)
  }

  return result.url as string
}
